import _get from 'lodash/get';

function makeKeyGetter(keyField, valueField) {
    if (typeof(keyField) === 'function') {
        return keyField;
    }

    if (!keyField && !valueField) {
        return data => data;
    }

    const keyName = keyField || valueField || null;
    if (keyName) {
        return data => _get(data, keyName);
    }

    return (_, index) => index;
}

function makeLabelGetter(labelField, valueField) {
    if (typeof(labelField) === 'function') {
        return labelField;
    }

    const labelName = labelField || valueField || null;
    if (labelName) {
        return data => _get(data, labelName);
    }

    return data => data;
}

function makeValueGetter(valueField) {
    if (typeof(valueField) === 'function') {
        return valueField;
    }

    const valueName = valueField || null;
    if (valueName) {
        return data => _get(data, valueName);
    }

    return data => data;
}

export { makeKeyGetter, makeLabelGetter, makeValueGetter };